var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSegment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.54286 3.29284C8.15238 3.60713 8.15238 4.39287 7.54286 4.70716L1.37143 7.88938C0.761905 8.20368 0 7.81081 0 7.18222V0.817777C0 0.18919 0.761905 -0.203677 1.37143 0.110616L7.54286 3.29284Z",
    fill: "#3AB54A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSegment);
export default __webpack_public_path__ + "static/media/icon-segment.61052a3b50fd53df10d3e786622532f2.svg";
export { ForwardRef as ReactComponent };